module.exports = __webpack_public_path__ + "static/img/SketchPng33200c15b8571c1582c373ecf64b96582402608313a8eb40878106af0a345d0c.fc8a2de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SketchPng33200c15b8571c1582c373ecf64b96582402608313a8eb40878106af0a345d0c.png
// module id = TcYO
// module chunks = 1